import React from "react";
import Chart from "react-apexcharts";
import CardComponent from "../../../components/CardComponent";

const SupplierPieChart = ({ rows, valueType }) => {
  const isEnergy = valueType === "Energy";

  const series = isEnergy
    ? [
      rows?.totalCompanies?.Energy_company || 0,
      rows?.totalCompanies?.zones || 0,
      rows?.totalCompanies?.regional_offices || 0,
      rows?.totalCompanies?.sales_area || 0,
      rows?.totalCompanies?.districts || 0,
    ]
    : [
      rows?.totalCompanies?.[`Requested${valueType}`] || 0,
      rows?.totalCompanies?.[`Approved${valueType}`] || 0,
      rows?.totalCompanies?.[`Rejected${valueType}`] || 0,
    ];

  const labels = isEnergy
    ? ["Energy Companies", "Zones", "Regional Offices", "Sales Areas", "Districts"]
    : ["Requested", "Approved", "Rejected"];

  const colors = isEnergy
    ? ["#5200ff", "#09bd94", "#f16a1b", "#00bcd4", "#f44336"]
    : ["#5200ff", "#09bd94", "#f16a1b"];

  const chartData = {
    series,
    options: {
      chart: {
        type: "donut",
        toolbar: { show: false },
        responsive: true,
      },
      labels,
      legend: { position: "bottom" },
      tooltip: { enabled: true },
      dataLabels: {
        enabled: true,
        formatter: (_, opts) => opts?.w?.config?.series[opts?.seriesIndex],
      },
      fill: { type: "gradient" },
      colors,
    },
  };

  return (
    <CardComponent showCardHeader={true} title="Pie Chart Analysis" classbody="d-align">
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="donut"
        height={300}
      />
    </CardComponent>
  );
};

export default SupplierPieChart;
